import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import classNames from 'classnames'
import { Field } from '@matillion/component-library'

import classes from 'modules/FormsContent/Form.module.scss'
import { FormValues } from 'modules/Projects/CreateSchedule/types'

export const ScheduleName: FunctionComponent = () => {
  const { errors, handleBlur, handleChange, touched, values } =
    useFormikContext<FormValues>()
  const { t } = useTranslation()

  return (
    <div data-testid="create-schedule-schedule-name">
      <Field
        title={t('createSchedule.fields.scheduleName.title')}
        name="name"
        data-testid="create-schedule-schedule-name-input"
        value={values.name}
        placeholder={t('createSchedule.fields.scheduleName.placeholderText')}
        onChange={handleChange}
        onBlur={handleBlur}
        className={classNames(classes.Form__Field)}
        supportText={t('createSchedule.fields.scheduleName.supportText')}
        errorText={errors?.name && touched.name ? t(errors.name) : null}
        hasError={!!errors?.name && touched.name}
        required
      />
    </div>
  )
}
